<template>
  <div class="treaty-page">
    <myHeader :title="title"></myHeader>
    <div class="content" v-html="detail"></div>
  </div>
</template>

<script>
import myHeader from "@/components/Header";
export default {
  name: "Treaty",
  components: {
    myHeader
  },
  data() {
    return {
      name: this.$route.query.name,
      title: {
        name: ""
      },
      detail: ""
    };
  },
  methods: {
    getDetail() {
      this.$http
        .get("/api/contract/get", {
          params: this.name
        })
        .then(res => {
          this.detail = res[this.name];
        });
    }
  },
  created() {
    switch (this.name) {
      case "user_register_contract":
        this.title.name = "用户注册协议";
        break;
      case "user_protect_contract":
        this.title.name = "用户隐私保护协议";
        break;
      case "charge_contract":
        this.title.name = "充值协议";
        break;
      case "customer_chat_contract":
        this.title.name = "客服协议";
        break;
      case "coupon_use_contract":
        this.title.name = "优惠券使用协议";
        break;
      case "vip_user_contract":
        this.title.name = "会员协议";
        break;
      default:
        break;
    }
    this.getDetail();
  }
};
</script>

<style lang='scss' scoped>
.about-page {
  width: 100%;
  overflow: hidden;
  .content {
    /deep/ img {
      width: 100%;
    }
  }
}
</style>
